import { Board } from '@ih/app/shared/apis/interfaces';

export class DeleteBoardSuccess {
  public static readonly type =
    '[Project/Manager/List] DeleteBoardSuccessEffect';
  constructor(public readonly board: Board | null | undefined) {}
}
